let carfFormSelection = document.getElementById('carf-form');
window.carfGlobalElementObject = {};
if (Boolean(carfFormSelection)) {
    let reportTypeDropDown = carfFormSelection.querySelector("#reportType");
    carfGlobalElementObject.openDropDown = function(event, setFocusTarget) {
        let moreButton = document.querySelector(".icon-0024_dropdown-more");
        moreButton.classList.toggle("down");
        // Handy vars for various menu dom nodes and IDs.
        var menuId = event.currentTarget.getAttribute('aria-controls');    // this is the ID of the UL. JJ IMPROVING.. call this menuId
        var menu = document.getElementById(menuId);   // this is the UL.  JJ IMPROVING.. call this menu
        var controllerInputID = menu.getAttribute('aria-labelledby'); // needed for proper closure of menu and returning focus to controlling Input.
        var menuContainerId = menu.parentNode.id; // This is the id of the div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
        var dropdownToOpen = document.getElementById(menuContainerId);   // This is the dom element div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
      
        // Begin Adding Toggle effect - want to have dropdown such that if user clicks it once it opens and clicking again will close it.
        // but support the case where they may click to open and then use a keypress to get to the menu item
         // see what the event key code was. If it was Key Down or Key Up or other Atria - then do not close the menu. They may have been hitting e.g. Down Arrow to move focus to first item
         var preserveOpenState = false;
         if (event.keyCode) { // if user pressed a key do not close the dropdown. It should be false if user clicked it. Really only want a convenience Toggle off the user clicks it open. Then can click to close.
           preserveOpenState = true;
          //  console.log('***** Leaving menu visible. User probably using Key interactions again on the Input after it is open  ******')
         }
      
        // first check if it's closed. If it is then open it. Also if user has done a key down in the Input.
        if (dropdownToOpen.classList.contains("wuds-is-closed") || preserveOpenState) {   // THIS IS THE TOGGLE ON 
      
          // console.log('***** TOGGLING MENU ON ******')
      
          // see if there is a modal version of the dropdown to open - this is expected for Country Dropdown
          var isMobileModal = document.getElementById(menuContainerId+'-modal');
      
        //   if (breakpointDeviceInUse.value == 'S-size-device' && isMobileModal) { // open the modal which presumes and relies on id being same as that of targetDropdown except with "-modal" appended to it
        //     // console.log('S-size-device breakpoint so open modal');
        //     dropdownToOpen = document.getElementById(menuContainerId+'-modal');
        //   }
      
          // now show the Dropdown (and focus should be on matched element)
          dropdownToOpen.classList.remove("wuds-is-closed"); // remove inactive border color
          dropdownToOpen.classList.add("wuds-is-open");
      
          // See  if need to set focus
          if (setFocusTarget) {
      
            if (setFocusTarget == 'focusOnFirst') {
      
              var popupMenuFirstItem = menu.firstElementChild;
              var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
              popupMenuFirstItemAnchor.focus();
      
            } else if (setFocusTarget == 'focusOnLast') {
      
              var popupMenuLastItem = menu.lastElementChild;
              var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child
              popupMenuLastItemAnchor.focus();
      
            }
          }
      
          // lastly set the aria-expanded="true"    for the Input controller of the menu
          event.currentTarget.setAttribute('aria-expanded',true);
      
          console.log('Inside openPseudoDropdown');
      
        }  else {
      
            console.log('***** TOGGLING MENU OFF ******')
            carfGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
      
        }
      
    }
      carfGlobalElementObject.closeDropdown = function (targetDropdownId, inputToUpdateId) {
        var dropdown = document.getElementById(targetDropdownId);
        dropdown.classList.add("wuds-is-closed"); 
        dropdown.classList.remove("wuds-is-open"); 
        var cancelIcon = document.getElementsByClassName("wuds-dropdown__search__cancel__icon");
        if(cancelIcon[0]){ cancelIcon[0].classList.add("d-none");}
        // lastly set the aria-expanded="false"    for the Input controller of the menu and place focus on the Input
        var targetInput = document.getElementById(inputToUpdateId);
        targetInput.setAttribute('aria-expanded',false);
      
        var controllerInput = document.getElementById(inputToUpdateId);
        controllerInput.focus();
      }
      carfGlobalElementObject.justcloseDropdown = function (targetDropdownId, inputToUpdateId) {
        var dropdown = document.getElementById(targetDropdownId);
        dropdown.classList.add("wuds-is-closed"); 
        dropdown.classList.remove("wuds-is-open"); 
        var cancelIcon = document.getElementsByClassName("wuds-dropdown__search__cancel__icon");
        if(cancelIcon[0]){ cancelIcon[0].classList.add("d-none");}
        // lastly set the aria-expanded="false"    for the Input controller of the menu and place focus on the Input
        var targetInput = document.getElementById(inputToUpdateId);
        targetInput.setAttribute('aria-expanded',false);
      }
      carfGlobalElementObject.handleKeydownOnInput = function  (event, specialMenu) {

        var keyCodeObj = Object.freeze({
          'TAB': 9,
          'RETURN': 13,
          'ESC': 27,
          'SPACE': 32,
          'PAGEUP': 33,
          'PAGEDOWN': 34,
          'END': 35,
          'HOME': 36,
          'LEFT': 37,
          'UP': 38,
          'RIGHT': 39,
          'DOWN': 40
        });
      
        // SEE IF IT CONTROLS MENU
        // IF SO - call function that opens the menu and places focus at first position
        var popupMenuExists = event.currentTarget.getAttribute('aria-controls');
      
        if (popupMenuExists) {  // IF popup menu exists then determine key pressed and what to do for it
      
          var flag = false;
      
          switch (event.keyCode) { // see if the keycode matches a value of interest in keyCode object of interesting values.
            case keyCodeObj.SPACE:
            case keyCodeObj.RETURN:
            case keyCodeObj.DOWN:   
                 var result = carfGlobalElementObject.openDropDown(event, 'focusOnFirst');
                 flag = true;
              break;
      
            case keyCodeObj.UP:
                 var result = carfGlobalElementObject.openDropDown(event, 'focusOnLast'); 
                 flag = true;
              break;
      
            default:
              break;
          }
      
          if (flag) {
            event.stopPropagation();
            event.preventDefault();
          }
        }
      };
      carfGlobalElementObject.setInputAnswer = function (event) {
        // Relying on knowing markup structure to traverse up to find key parent elements etc. 
        // Update Input with selected value
        var answer = event.currentTarget.querySelector("span").innerHTML; // anchor child is span. Inner html of span we will use as answer.
        var answerKeyValue = event.currentTarget.getAttribute("data-keyvalue");
        var currentListItem = event.currentTarget.parentNode; // Anchor's Parent  is LI. As the user clicks that Lists items Anchor. To drive e.g. previous/next item navigation will need this.
        var menu = currentListItem.parentNode; // LI's parent is  UL 
        var controllerInputId = menu.getAttribute('aria-labelledby'); // ID of Controlling Input is handily in Aria attribute. 
        var menuContainerId = menu.parentNode.getAttribute('id'); // UL's parent is the container div we update to either "wuds-is-closed" or "wuds-is-open".
        var controllerInputElementId = document.getElementById(controllerInputId);
        if(controllerInputElementId){
            controllerInputElementId.value = answer;
            controllerInputElementId.setAttribute("data-value",answer);
            if(answerKeyValue && answerKeyValue != null && answerKeyValue !== ""){
              controllerInputElementId.setAttribute("data-keyvalue",answerKeyValue);
            }
            carfGlobalElementObject.hideValidationMessage(controllerInputElementId);
        }
        var isOptionTypeAvailable =  event.currentTarget.getAttribute("data-optiontype"); 
        var isOptionTypeInfo =  event.currentTarget.getAttribute("data-optiontypeinfo");
        if(isOptionTypeAvailable && isOptionTypeInfo){
            //console.log(isOptionTypeAvailable);
            //console.log(isOptionTypeInfo);
            controllerInputElementId.setAttribute("data-selectedOptionType",isOptionTypeAvailable);
            let enableSpecificTransferDivElements = carfFormSelection.querySelectorAll(".specificTypeDetailContainer");
            let historyOptionTypeContainer = carfFormSelection.querySelector('#historyOptionTypeContainer');
            if(historyOptionTypeContainer){
                historyOptionTypeContainer.innerHTML = isOptionTypeInfo;
            }
            if(isOptionTypeAvailable == "Specific money transfers"){
                historyOptionTypeContainer.classList.add('text-danger');        
                if(enableSpecificTransferDivElements){
                    enableSpecificTransferDivElements.forEach((element) => {
                       element.classList.remove('d-none')
                    });
                }                    
            }else {
                historyOptionTypeContainer.classList.remove('text-danger');   
                if(enableSpecificTransferDivElements){
                    enableSpecificTransferDivElements.forEach((element) => {
                       element.classList.add('d-none')
                    });
                }
            }
        }
        

        // special case though is Mobile where it's a modal so need to close this: country-11-dropdown-modal and not this: country-11-dropdown-modal-dropdown
        // going to strip off "-dropdown" IF 'modal-dropdown' is part of the classname.
        var isMobileModal = menuContainerId.indexOf('modal-dropdown') !== -1;
        if (isMobileModal) {
          menuContainerId = menuContainerId.replace('modal-dropdown','modal');
        }
      
        carfGlobalElementObject.closeDropdown(menuContainerId, controllerInputId);
    }
    carfGlobalElementObject.setFocusToPreviousMenuItem = function (currentListItem) {
        var previousListItem = currentListItem.previousElementSibling;
      
        if (previousListItem) {
          var previousItemAnchor = previousListItem.firstElementChild;
          if (previousItemAnchor) {
            previousItemAnchor.focus();
          }
        } else {
          // must be first item. So find parent UL and go to last child's anchor. 
          var parentUL = currentListItem.parentNode;
          var popupMenuLastItem = parentUL.lastElementChild;
          var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child
          popupMenuLastItemAnchor.focus();
        }
      
      
      }
      
      // helper function for dropdown menu interaction
      // determine next menu item and place focus on it.
      // if there is no next item then place focus on first menu item.
      // @param currentListItem - dom node of current List Item (the LI). The menu construct is assumed to be UL with LI child elements that each have one Anchor child - that has the click and keypress events
      carfGlobalElementObject.setFocusToNextMenuItem = function (currentListItem) {
      
        // user clicked the anchor inside the LI item.  So try to find next LI item and if it exists then it's child anchor and place focus on it
      
        var nextListItem = currentListItem.nextElementSibling;
      
        if (nextListItem) {
          var nextItemAnchor = nextListItem.firstElementChild;
          if (nextItemAnchor) {
            nextItemAnchor.focus();
          }
        } else {
          // must be last item. So find parent UL and go to first child's anchor. 
          var parentUL = currentListItem.parentNode;
          var popupMenuFirstItem = parentUL.firstElementChild;
          var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
          popupMenuFirstItemAnchor.focus();
        }
      
      }
      
      // used for PAGEDOWN keydown
      // @param menu dom node of the UL menu
      carfGlobalElementObject.setFocusToFirstMenuItem = function (menu) {
        var popupMenuFirstItem = menu.firstElementChild;
        var popupMenuFirstItemAnchor = popupMenuFirstItem.firstElementChild; // assumes anchor is first child
        popupMenuFirstItemAnchor.focus();
      }
      
      // used for PAGEDOWN keydown
      // @param menu dom node of the UL menu
      carfGlobalElementObject.setFocusToLastMenuItem = function (menu) {
        var popupMenuLastItem = menu.lastElementChild;
        var popupMenuLastItemAnchor = popupMenuLastItem.firstElementChild; // assumes anchor is first child of the lI
        popupMenuLastItemAnchor.focus();
      }
      
      // this can be implemented as well by setting a global variable for lastFocusedInput for example when the user presses key in the input. The key press handler can set it. Then just reference that to return
      // focus to the controlling input.
      // In this example -we leverage the fact that the Aria Labeled By (aria-labelledby) attribute of the UL list is the ID of the controlling input to place focus on.
      // @param currentListItem dom node of current List Item (the LI).
      carfGlobalElementObject.setFocusToController = function (currentListItem) {
        var controllerInputID = currentListItem.getAttribute('aria-labelledby');
        document.getElementById(controllerInputID).focus();
      }
      carfGlobalElementObject.dropDownSearchKeyUpEventHandler = function (event) {
        var searchInput = event.currentTarget.value;
        var menuId = event.currentTarget.getAttribute('aria-controls');
        var menu = document.getElementById(menuId); 
        var menuListitems = menu.querySelectorAll(".wuds-dropdown__item");
        
        for (let i = 0; i <= menuListitems.length - 1; i++) {
          //console.log(menuListitems[i].getElementsByClassName("dropdown-lists-span"));
          let title = menuListitems[i].getElementsByClassName("dropdown-lists-span")[0].innerText
          //console.log(title);
          if (title.toUpperCase().indexOf(searchInput.toUpperCase()) > -1) {
            menuListitems[i].style.display = "";    
          } else {
            menuListitems[i].style.display = "none";
          }
        }
      }
    carfGlobalElementObject.handleKeydownOnMenuItem = function  (event) {

        var keyCodeObj = Object.freeze({
          'TAB': 9,
          'RETURN': 13,
          'ESC': 27,
          'SPACE': 32,
          'PAGEUP': 33,
          'PAGEDOWN': 34,
          'END': 35,
          'HOME': 36,
          'LEFT': 37,
          'UP': 38,
          'RIGHT': 39,
          'DOWN': 40
        });
      
        var flag = false;
      
        // Handy vars for various menu dom nodes and IDs.
        var currentListItem = event.currentTarget.parentNode; // handy to know what the current list item is. As the user clicks that Lists items Anchor. To drive e.g. previous/next item navigation will need this.
        var currentListItemAnchor = event.currentTarget; // this assumes all our click events are on the anchor tag within list item.
      
        var menu = currentListItem.parentNode; // this is the UL.
        var menuContainerId =menu.parentNode.id; // This is the id of the div that contains the UL. Needed for proper menu closure.  wuds-is-open, wuds-is-closed is applied to it.
        var controllerInputID = menu.getAttribute('aria-labelledby'); // needed for proper closure of menu and returning focus to controlling Input.
      
        switch (event.keyCode) {
          case keyCodeObj.SPACE:
            flag = true;
            break;
      
          case keyCodeObj.RETURN:
            currentListItemAnchor.click(); // trigger the click event - and the listener for that will fire. 
            flag = true;
            break;
      
          case keyCodeObj.ESC:
            carfGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
            flag = true;
            break;
      
          case keyCodeObj.UP:
            carfGlobalElementObject.setFocusToPreviousMenuItem(currentListItem);  // put focus on previous menu item (the previous LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.DOWN:
            carfGlobalElementObject.setFocusToNextMenuItem(currentListItem);   // put focus on next menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.HOME:
          case keyCodeObj.PAGEUP:
            carfGlobalElementObject.setFocusToFirstMenuItem(menu);   // put focus on first menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.END:
          case keyCodeObj.PAGEDOWN:
            carfGlobalElementObject.setFocusToLastMenuItem(menu);   // put focus on last menu item (the next LI's anchor element)
            flag = true;
            break;
      
          case keyCodeObj.TAB:
            carfGlobalElementObject.closeDropdown(menuContainerId, controllerInputID);  // close menu, return focus to controlling Input
            // this.popupMenu.setFocusToController();
            // this.popupMenu.close(true);
            break;
      
          default:
            // if (isPrintableCharacter(char)) {
            //   this.popupMenu.setFocusByFirstCharacter(this, char);
            // }
            break;
        }
      
        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
      
    const setDropDownEventListeners = () => {
        let dropDownArray = carfFormSelection.getElementsByClassName("wu-input--dropdown");
        Array.from(dropDownArray).forEach(function(element) {

            element.addEventListener("click", function() { 
                carfGlobalElementObject.openDropDown(event); 
            });
        
            element.addEventListener("keydown", function() { 
                carfGlobalElementObject.handleKeydownOnInput(event); 
            });

            element.addEventListener("keyup", function() { 
              carfGlobalElementObject.dropDownSearchKeyUpEventHandler(event); 
            });
        
          }); 
          var wuDropdownMenuItems =  carfFormSelection.getElementsByClassName("wuds-dropdown__item");

          Array.from(wuDropdownMenuItems).forEach(function(element) {
        
            // only add event listener if the item does not have "wuds-dropdown__item--disabled"
            if ( element.classList.contains("wuds-dropdown__item--disabled") ) {
              //do nothing - don't add listener
            } else {
              // find first anchor within it
              var anchor = element.querySelector("a");
        
              anchor.addEventListener("click", function() { 
                carfGlobalElementObject.setInputAnswer(event); 
              });
        
              anchor.addEventListener("keydown", function() { 
                carfGlobalElementObject.handleKeydownOnMenuItem(event);
              });
            }
        
          }); // end loop through elements that matched on class name
          var ip = carfFormSelection.querySelectorAll(".wu-input");
          carfFormSelection.addEventListener("DOMContentLoaded", stat);

          for (var i = 0; i < ip.length; i++) {
            if (ip[i].addEventListener) {
              ip[i].addEventListener("change", stat);
              ip[i].addEventListener("blur", stat);
            } else if (ip[i].attachEvent) {
              ip[i].attachEvent("change", stat);
              ip[i].attachEvent("blur", stat);
            }
          }

          function stat() {
            for (var i = 0; i < ip.length; i++) {
              if (ip[i].value != '') {
                ip[i].classList.add("wu-input--is-focus");
              } else if (ip[i].value == '') {
                ip[i].classList.remove("wu-input--is-focus");
              }
            }
          }
          carfFormSelection.addEventListener("click", function(e){
              if (e.target.parentNode.classList && e.target.parentNode.classList.value && e.target.parentNode.classList.value.indexOf('wuds-dropdown') === -1
              && e.target.parentNode.classList.value.indexOf('wu-input--dropdown') == -1) {
                carfGlobalElementObject.justcloseDropdown("languageDropDown-dropdown","languageDropDown");
                carfGlobalElementObject.justcloseDropdown("reportType-dropdown","reportType");
                carfGlobalElementObject.justcloseDropdown("countryCode-dropdown","countryCode");
              }
            
          });

    }
    const setDatePickers = () =>{
        var today = new Date(); 
        var startDateSet = new Date();
        startDateSet.setFullYear(startDateSet.getFullYear() - 10);
        jQuery( "#fromDate" ).datepicker({
          showAnim: "slideDown",
          changeMonth: true,
          changeYear : true,
          startDate:startDateSet,
          endDate:today,
          maxDate: 0,
          onSelect: function() {
            let fromDateElementObject = document.getElementById('fromDate');
            fromDateElementObject.classList.add("wu-input--is-focus");
            carfGlobalElementObject.hideValidationMessage(fromDateElementObject);
            var x=jQuery('#fromDate').datepicker("getDate");
            jQuery( "#toDate" ).datepicker( "option", "minDate",x ); 
            jQuery( "#toDate" ).datepicker( "option", "startDate",x ); 
         }
        });
        jQuery( "#toDate" ).datepicker({
          showAnim: "slideDown",
          changeMonth: true,
          changeYear : true,
          endDate:today,
          maxDate: 0,
          onSelect: function() {
            let toDateElementObject = document.getElementById('toDate');
            toDateElementObject.classList.add("wu-input--is-focus");
            carfGlobalElementObject.hideValidationMessage(toDateElementObject);
         }
        });
        
    }
    carfGlobalElementObject.showValidationMessage  = function  (targetElement) {
      targetElement.parentNode.classList.add('wu-input__error');
      let targetElementId = targetElement.getAttribute("id");
      let errorEelementDiv = carfFormSelection.querySelector("."+targetElementId+"-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.remove("d-none");
      }
    }
    carfGlobalElementObject.hideValidationMessage  = function  (targetElement) {
      targetElement.parentNode.classList.remove('wu-input__error');
      let targetElementId = targetElement.getAttribute("id");
      let errorEelementDiv = carfFormSelection.querySelector("."+targetElementId+"-error");
      if(errorEelementDiv){
        errorEelementDiv.classList.add("d-none");
      }
    }
    carfGlobalElementObject.onKeyPressEventOfInputFields  = function  (event) {
      let elementId = event.currentTarget.id;
      let elementObject = document.getElementById(elementId);
      carfGlobalElementObject.hideValidationMessage(elementObject);
    }
    carfGlobalElementObject.triggerValidation  = function  (event) {

      let fromDateEL =  carfFormSelection.querySelector("#fromDate");
      let toDateEL =  carfFormSelection.querySelector("#toDate");
      let emailAddressEL =  carfFormSelection.querySelector("#emailAddress");
      let phoneNumberEL =  carfFormSelection.querySelector("#phoneNumber");
      let countryCodeEL =  carfFormSelection.querySelector("#countryCode");
      let stateEL =  carfFormSelection.querySelector("#state");
      let cityEL =  carfFormSelection.querySelector("#city");
      let postalCodeEL =  carfFormSelection.querySelector("#postalCode");
      let streetAddressEL =  carfFormSelection.querySelector("#streetAddress");
      let otherEmailAddressEL =  carfFormSelection.querySelector("#otherEmailAddress");
      let reportTypeEL =  carfFormSelection.querySelector("#reportType");
      let uploadFileEl = carfFormSelection.querySelector("#carfUploadFiles");
      let humanKeyEL = carfFormSelection.querySelector("#humanKey");
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      let preferredLanguageEl =  carfFormSelection.querySelector("#carf_prefered_language");
      let isFormValid = true;
      let returnObject = {};
      if(stateEL){
        let state = stateEL.value;
        if(state !== undefined  && state == ""){
          returnObject['state'] = "";
        }else{
          returnObject['state'] = state;
        }
      }
      if(postalCodeEL){
        let postalCode = postalCodeEL.value;
        if(postalCode !== undefined  && postalCode == ""){
          returnObject['postalCode'] = "";
        }else{
          returnObject['postalCode'] = postalCode;
        }
      }
     
     
      if(humanKeyEL){
        carfGlobalElementObject.hideValidationMessage(humanKeyEL);
        let capatchValue = humanKeyEL.value;
        returnObject['humanKey'] = capatchValue;
        if(capatchValue !== undefined  && capatchValue == ""){
          carfGlobalElementObject.showValidationMessage(humanKeyEL);
          isFormValid = false;
        }else{
          returnObject['humanKey'] = capatchValue;
        }
      }
      let selectedFilesArray = carfGlobalElementObject.fileArray;
      if(selectedFilesArray){
        let uploadFileEl = carfFormSelection.querySelector("#carfUploadFiles");
        if(selectedFilesArray.length == 0){
          
          carfGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.add("wu-dropzone-error");
          isFormValid = false;
          uploadFileEl.focus();
        }else {
          carfGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.remove("wu-dropzone-error");
        }
      }
       
       if(otherEmailAddressEL){
        carfGlobalElementObject.hideValidationMessage(otherEmailAddressEL);
        let otherEmailAddress = otherEmailAddressEL.value;
        if(otherEmailAddress !== undefined){
          if(otherEmailAddress != "" && !otherEmailAddress.match(mailformat)){
            carfGlobalElementObject.showValidationMessage(otherEmailAddressEL);
            isFormValid = false;
            otherEmailAddressEL.focus();
          }else{
            returnObject['otherEmailAddress'] = otherEmailAddress;
          }
        }
        
      }
       if(streetAddressEL){
        carfGlobalElementObject.hideValidationMessage(streetAddressEL);
        let streetAddress = streetAddressEL.value;
        if(streetAddress !== undefined  && streetAddress == ""){
          carfGlobalElementObject.showValidationMessage(streetAddressEL);
          isFormValid = false;
          streetAddressEL.focus();
        }else{
          returnObject['streetAddress'] = streetAddress;
        }
      }
       if(cityEL){
        carfGlobalElementObject.hideValidationMessage(cityEL);
        let city = cityEL.value;
        if(city !== undefined  && city == ""){
          carfGlobalElementObject.showValidationMessage(cityEL);
          isFormValid = false;
          cityEL.focus();
        }else{
          returnObject['city'] = city;
        }
      }
       if(countryCodeEL){
        carfGlobalElementObject.hideValidationMessage(countryCodeEL);
        let countryCode = countryCodeEL.value;
        if(countryCode !== undefined  && countryCode == ""){
          carfGlobalElementObject.showValidationMessage(countryCodeEL);
          isFormValid = false;
          countryCodeEL.focus();
        }else{
          let countryKeyValue = countryCodeEL.getAttribute("data-keyvalue");
          let countryName = CARF_COUNTRY_LIST[countryKeyValue];
          returnObject['countryCode'] = countryName;
        }
      }
       if(phoneNumberEL){
        carfGlobalElementObject.hideValidationMessage(phoneNumberEL);
        let phoneNumber = phoneNumberEL.value;
        if(phoneNumber !== undefined  && phoneNumber == ""){
          carfGlobalElementObject.showValidationMessage(phoneNumberEL);
          isFormValid = false;
          phoneNumberEL.focus();
        }else{
          returnObject['phoneNumber'] = phoneNumber;
        }
       }
       if(emailAddressEL){
        carfGlobalElementObject.hideValidationMessage(emailAddressEL);
        let emailAddress = emailAddressEL.value;
        if(emailAddress !== undefined){
          if(emailAddress == ""){
            carfGlobalElementObject.showValidationMessage(emailAddressEL);
            isFormValid = false;
            emailAddressEL.focus();
          }else if(!emailAddress.match(mailformat)){
            carfGlobalElementObject.showValidationMessage(emailAddressEL);
            isFormValid = false;
            emailAddressEL.focus();
          }else{
            returnObject['emailAddress'] = emailAddress;
          }
        }
        
      }
       if(reportTypeEL){   
        let customerNameListEL =  carfFormSelection.querySelector("#customerNameList");
        let customerMtcnListEL =  carfFormSelection.querySelector("#customerMtcnList");
        if(customerNameListEL){  
          carfGlobalElementObject.hideValidationMessage(customerNameListEL);
        }
        if(customerMtcnListEL){  
          carfGlobalElementObject.hideValidationMessage(customerMtcnListEL);
        }
        let selectedOptionType = reportTypeEL.getAttribute("data-selectedOptionType");
        if(selectedOptionType == null || selectedOptionType == ""){
          selectedOptionType = "Sent and received money transfers";
        }
        returnObject['selectedReportTypeOptionValue'] = selectedOptionType;
        returnObject['selectedOptionType'] = selectedOptionType;
        if(selectedOptionType && selectedOptionType !== "" && selectedOptionType == "Specific money transfers"){
          if(customerNameListEL){           
            let customerNameList = customerNameListEL.value;
            if(customerNameList !== undefined  && customerNameList == ""){
              carfGlobalElementObject.showValidationMessage(customerNameListEL);
              customerNameListEL.focus();
            }else{
              returnObject['customerNameList'] = customerNameList;
            }
          }
          if(customerMtcnListEL){        
            let customerMtcnList = customerMtcnListEL.value;
            if(customerMtcnList !== undefined  && customerMtcnList == ""){
              carfGlobalElementObject.showValidationMessage(customerMtcnListEL);
              customerMtcnListEL.focus();
            }else{
              returnObject['customerMtcnList'] = customerMtcnList;
            }
          }
        }
       }
       if(toDateEL){
        carfGlobalElementObject.hideValidationMessage(toDateEL);
        let toDate = toDateEL.value;
        if(toDate !== undefined  && toDate == ""){
          carfGlobalElementObject.showValidationMessage(toDateEL);
          isFormValid = false;
          toDateEL.focus();
        }else{
          returnObject['toDate'] = toDate;
        }
      }
       if(fromDateEL){
        carfGlobalElementObject.hideValidationMessage(fromDateEL);
        let fromDate = fromDateEL.value;
        if(fromDate !== undefined && fromDate == ""){
          carfGlobalElementObject.showValidationMessage(fromDateEL);
          isFormValid = false;
          fromDateEL.focus();
        }else{
          returnObject['fromDate'] = fromDate;
        }
      }
      console.log('Validation Event Triggered-- Status='+isFormValid);
      if(isFormValid == true){
        returnObject['status'] = "success";
      }else{
        returnObject['status'] = "error";
      }
      
      if(preferredLanguageEl){
        let preferredLanguage = preferredLanguageEl.value;
        returnObject['preferredLanguage'] = preferredLanguage.toLowerCase();
      }else{
        returnObject['preferredLanguage'] = "english";
      }

      return returnObject;
    }
    carfGlobalElementObject.fileArray = [];
    carfGlobalElementObject.fileBase64Array = [];
    carfGlobalElementObject.handleFileUploadEvent = function  (evt) {
      let uploadFileExtErorEl = carfFormSelection.querySelector(".carfUploadFiles-format-error"); 
      uploadFileExtErorEl.classList.add('d-none');
      let currentSelectedFiles = Array.from(evt.target.files);
      for(let i=0;i<currentSelectedFiles.length;i++){
        let fileObject = currentSelectedFiles[i];
        if(carfGlobalElementObject.isValidFileExtension(fileObject)){
          carfGlobalElementObject.fileArray.push(fileObject);
        }else {
          uploadFileExtErorEl.classList.remove('d-none');
        }
         
      }
      carfGlobalElementObject.addFileListUIelement();
      console.log('file Upload Event Triggered');
      let uploadFileEl = carfFormSelection.querySelector("#carfUploadFiles"); 
      carfGlobalElementObject.hideValidationMessage(uploadFileEl); 
      uploadFileEl.parentNode.classList.remove("wu-dropzone-error");
    }
    carfGlobalElementObject.getFileName = function(fileObject){
      let size=0;
      let fileName = "" ;
      if(fileObject.size>1000000){
          size=(fileObject.size/1024)/1024
         return  fileName = fileObject.name+" "+size.toFixed(2)+" MB ";

      }else{
          size=fileObject.size/1024
         return fileName = fileObject.name+" "+size.toFixed(2)+" KB ";

       }
    }
    carfGlobalElementObject.getFileSizeInLimit = function(){
      let totalsize=0;
      for(let i=0;i<carfGlobalElementObject.fileArray.length;i++){
        let fileObject = carfGlobalElementObject.fileArray[i];
        totalsize+=fileObject.size;
      }
      if(totalsize>1000000){
         let size=(totalsize/1024)/1024;
          if(size > 25){
            return false;
          }else {
            return true;
          }
      }else{
         return true;
       }
    }
    carfGlobalElementObject.isValidFileExtension = function(fileObject){
      let fileExtension = fileObject.name.split('.').pop();
      let carfFormSupportedExtentions = ['doc', 'docx' ,'pdf' ,'jpeg', 'jpg' ];
      if(carfFormSupportedExtentions.indexOf(fileExtension.toLowerCase()) === -1){
        return false;
      }else {
        return true;
      }
    }
    carfGlobalElementObject.removeUploadedFile = function(fileName){
      let tempArray = carfGlobalElementObject.fileArray;
      carfGlobalElementObject.fileArray = [];
      for(let i=0;i<tempArray.length;i++){
        let fileObject = tempArray[i];
        if(carfGlobalElementObject.getFileName(fileObject) == fileName){
           console.log('remove file found..');
        } else {
          carfGlobalElementObject.fileArray.push(fileObject);
        }  
      }
      carfGlobalElementObject.addFileListUIelement();
    }
    carfGlobalElementObject.addFileListUIelement = function(){
      let fileUielements="";
      let uploadFileSizeErrorEl =  carfFormSelection.querySelector(".carfUploadFiles-size-error");
      uploadFileSizeErrorEl.classList.add('d-none');
      for(let i=0;i<carfGlobalElementObject.fileArray.length;i++){
        let fileObject = carfGlobalElementObject.fileArray[i];
        let fileName = carfGlobalElementObject.getFileName(fileObject);
        fileUielements+= '<span class="wu-label wu-lable-info bk-inactive font-body-xxs mar-xs-rt">'+fileName+'<button title="Remove" class="wu-filter-remove" type="button" onclick="carfGlobalElementObject.removeUploadedFile(\''+fileName+'\');">x</button></span>';
      }
      let fileListContainerEl = carfFormSelection.querySelector("#fileListContainer");
      fileListContainerEl.innerHTML = fileUielements;
      if(carfGlobalElementObject.fileArray.length == 0){
        var carfUploadEL =  carfFormSelection.querySelector("#carfUploadFiles");
        carfUploadEL.value = "";
      }else if(carfGlobalElementObject.getFileSizeInLimit() == false){  
        uploadFileSizeErrorEl.classList.remove('d-none');
      }
    }
    carfGlobalElementObject.verfiyCaptcha = function(recaptcha_response){
      document.getElementById("humanKey").value = recaptcha_response;
      console.log(recaptcha_response);
    }
    carfGlobalElementObject.initateSubmitApi = async function(fromObject){
      let docFiles = [];
      let requestPayLoad = fromObject;
      let selectedFilesArray = carfGlobalElementObject.fileArray;
      if(selectedFilesArray){
        let uploadFileEl = carfFormSelection.querySelector("#carfUploadFiles");
        if(selectedFilesArray.length == 0){
          
          carfGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.add("wu-dropzone-error");
          return false;
        }else {
          carfGlobalElementObject.showValidationMessage(uploadFileEl); 
          uploadFileEl.parentNode.classList.remove("wu-dropzone-error");
        }
        for(let i=0;i<selectedFilesArray.length;i++){
          let fileObject = selectedFilesArray[i]
          let reader = new FileReader();
          reader.readAsDataURL(fileObject);
          reader.onload = function () {
            const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
            let uploadData = {
                "fileName": fileObject.name,
                "data": base64String,
            }
            docFiles.push(uploadData);
            if(docFiles.length == selectedFilesArray.length){
              requestPayLoad["docFiles"] = docFiles;
              carfGlobalElementObject.triggerSubmitApi(fromObject);
              
            }
          }
         }
      } else {
        //show file upload error...
      }
      
    }
    carfGlobalElementObject.showSpinner = function(){
      var showSpinnerBkgroundEl =  document.querySelector(".wu-spinner-overlay");
      var showSpinnerContainerEl =  document.querySelector(".wu-spinner");
      showSpinnerBkgroundEl.classList.remove('d-none');
      showSpinnerContainerEl.classList.remove('d-none');
    }
    carfGlobalElementObject.hideSpinner = function(){
      var showSpinnerBkgroundEl =  document.querySelector(".wu-spinner-overlay");
      var showSpinnerContainerEl =  document.querySelector(".wu-spinner");
      showSpinnerBkgroundEl.classList.add('d-none');
      showSpinnerContainerEl.classList.add('d-none');
    }
    carfGlobalElementObject.resetCaptcha = function(){
      var showSpinnerBkgroundEl =  carfFormSelection.querySelector("#humanKey");
      showSpinnerBkgroundEl.value="";
      if(grecaptcha){
        grecaptcha.reset();
      }
    }
    carfGlobalElementObject.triggerSubmitApi = async function(formObject){
      carfGlobalElementObject.showSpinner();
      let serviceURl = "https://www3.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postCarfForm";
      if (window.location.hostname == 'www2.westernunion.com') {
          serviceURl =  "https://www2.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postCarfForm";
        }
      else if (window.location.hostname == 'www.westernunion.com') {
        serviceURl = "https://www.westernunion.com/wuconnect/dcaas/caas-config/v1/initiateSSF/postCarfForm";
      }  
      let tempObject = {};
      tempObject["humanKey"] = formObject["humanKey"];
      tempObject["firstName"] ="";
      tempObject["lastName"] ="";
      tempObject["dateOfBirth"] ="";
      tempObject["wuCardNumber"] ="";
      tempObject["streetAddress"] = formObject["streetAddress"];
      tempObject["city"] = formObject["city"];
      tempObject["state"] = formObject["state"];
      tempObject["postalCode"] = formObject["postalCode"];
      tempObject["country"] = formObject["countryCode"];
      tempObject["phone"] = formObject["phoneNumber"];
      tempObject["email"] = formObject["emailAddress"];
      tempObject["dateOfRequest"] = formObject["fromDate"]+" - "+formObject["toDate"];
      tempObject["consent"]="true";
      tempObject["preferredLanguage"]=formObject["preferredLanguage"];
      let comments = "Report Type : "+formObject['selectedReportTypeOptionValue'];
     
      if(formObject['selectedOptionType'] == "Specific money transfers"){
        if(formObject['customerNameList']){
          comments+=", Name List : "+formObject['customerNameList'] +" ";
        }
        if(formObject['customerMtcnList']){
          comments+=", MTCN List : "+formObject['customerMtcnList'] +" ";
        }
        
      }
      if(formObject['otherEmailAddress']){
        comments+=",third party email: "+formObject['otherEmailAddress'];
      }  
      tempObject["comments"]=comments; 
      tempObject["suppliedComments"]="";
      tempObject["recordType"]={ "Name": "Interaction" };
      tempObject["docFiles"] = formObject["docFiles"];

      let requestPayload = tempObject;
      var xhr = new XMLHttpRequest();
      xhr.open("POST", serviceURl);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.onreadystatechange = function () {
        carfGlobalElementObject.hideSpinner();
          if (xhr.readyState == 4 && xhr.status == 200) {
               console.log('success');
               carfGlobalElementObject.showSubmitSuccessMessageFromApiResponse(xhr.responseText) 
          }
         
         console.log(xhr);
      };
      xhr.send(JSON.stringify(requestPayload));
    }
    carfGlobalElementObject.showSubmitSuccessMessageFromApiResponse = function  (response) {
      console.log(response);
      var caseNumbeEl =  carfFormSelection.querySelector(".carfSubmitButton-error");
      let caseNumber = "";
      let parsedResponse = JSON.parse(response);
      if(parsedResponse && parsedResponse['compositeResponse'] && parsedResponse['compositeResponse'].length >1){
        let responseArray = parsedResponse['compositeResponse'];
        if(responseArray[1].httpStatusCode == 200 && responseArray[1].referenceId == "ref_case_query"){
          if(responseArray[1]['body'] && responseArray[1]['body']['CaseNumber']){
            caseNumber = responseArray[1]['body']['CaseNumber'];
            carfGlobalElementObject.openMessageOverlay();
            var caseNumbeEl =  document.querySelector("#caseNumbeEl");
            if(caseNumbeEl){
              caseNumbeEl.innerText=caseNumber;
            }           
          }
        } else {
          carfGlobalElementObject.resetCaptcha();
          caseNumbeEl.classList.remove('d-none');
          
        }
      }    
   }
    carfGlobalElementObject.carfFormCancelEventHandler = function  (event) {
      carfGlobalElementObject.openWuHelpCenter();
    }
    carfGlobalElementObject.carfFormSubmitEventHandler  = function  (event) {
        console.log('Submit Event Triggered');
        let validatedFormObject = carfGlobalElementObject.triggerValidation();
        if(validatedFormObject['status'] == "success"){
          carfGlobalElementObject.initateSubmitApi(validatedFormObject);
        }
        
        console.log(validatedFormObject);
    }
    carfGlobalElementObject.openMessageOverlay = function() {
      var overLayContainer = document.querySelector('.wu-overlay');
      overLayContainer.style.display ="flex";
    }
    carfGlobalElementObject.openWuHelpCenter = function() {
      var win = window.open('https://wucare.westernunion.com/s/customer-care-home?language=en_US',"_self");
      win.focus()
    }
    const setButtonEventListeners  = function  (event) {
        var carfCancelButtonElement =  carfFormSelection.querySelector("#carfCancelButton");
        var carfSubmitButtonElement =  carfFormSelection.querySelector("#carfSubmitButton");
       
        
        carfCancelButtonElement.addEventListener("click", function() { 
            carfGlobalElementObject.carfFormCancelEventHandler(event); 
        });
    
        carfSubmitButtonElement.addEventListener("click", function() { 
            carfGlobalElementObject.carfFormSubmitEventHandler(event); 
        });
        
    }
    const loadCarfDefaultForm = () => {
        setDropDownEventListeners();
        setButtonEventListeners();
        setDatePickers();
       
    }
    let CARF_COUNTRY_LIST = {
      "AD": "Andorra",
      "AE": "United Arab Emirates",
      "AF": "Afghanistan",
      "AG": "Antigua And Barbuda",
      "AI": "Anguilla",
      "AL": "Albania",
      "AM": "Armenia",
      "AO": "Angola",
      "B1": "Bonaire",
      "AR": "Argentina",
      "AS": "American Samoa",
      "AT": "Austria",
      "AU": "Australia",
      "AW": "Aruba",
      "AZ": "Azerbaijan",
      "BB": "Barbados",
      "BD": "Bangladesh",
      "BE": "Belgium",
      "BF": "Burkina Faso",
      "BG": "Bulgaria",
      "BH": "Bahrain",
      "BI": "Burundi",
      "BJ": "Benin",
      "BL": "Saint Barthelemy",
      "BM": "Bermuda",
      "BN": "Brunei Darussalam",
      "BO": "Bolivia",
      "BA": "Bosnia and Herzegovina",
      "BR": "Brazil",
      "BS": "Bahamas",
      "BT": "Bhutan",
      "BW": "Botswana",
      "BY": "Belarus",
      "BZ": "Belize",
      "CA": "Canada",
      "CF": "Central African Republic",
      "CH": "Switzerland",
      "CI": "Ivory Coast",
      "CK": "Cook Islands",
      "CL": "Chile",
      "CM": "Cameroon",
      "CN": "China",
      "CO": "Colombia",
      "CR": "Costa Rica",
      "CU": "Cuba",
      "CV": "Cape Verde",
      "CW": "Curacao",
      "CY": "Cyprus",
      "CZ": "Czech Republic",
      "DE": "Germany",
      "DJ": "Djibouti",
      "DK": "Denmark",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "DZ": "Algeria",
      "EC": "Ecuador",
      "EE": "Estonia",
      "SWZ": "Eswatini",
      "EG": "Egypt",
      "ER": "Eritrea",
      "ES": "Spain",
      "ET": "Ethiopia",
      "FI": "Finland",
      "FK": "Falkland Islands (Malvinas)",
      "FJ": "Fiji",
      "FM": "Micronesia",
      "FR": "France",
      "GA": "Gabon",
      "GB": "United Kingdom",
      "GD": "Grenada",
      "GE": "Georgia",
      "GF": "French Guiana",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GL": "Greenland",
      "GM": "Gambia",
      "GN": "Guinea",
      "GP": "Guadeloupe",
      "GQ": "Equatorial Guinea",
      "GR": "Greece",
      "GT": "Guatemala",
      "GU": "Guam",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HK": "Hong Kong",
      "HN": "Honduras",
      "HR": "Croatia",
      "HT": "Haiti",
      "HU": "Hungary",
      "ID": "Indonesia",
      "IE": "Ireland",
      "IL": "Israel",
      "IN": "India",
      "IQ": "Iraq",
      "IR": "Iran",
      "IS": "Iceland",
      "IT": "Italy",
      "JM": "Jamaica",
      "JO": "Jordan",
      "JP": "Japan",
      "K1": "Kosovo",
      "KE": "Kenya",
      "KG": "Kyrghyz Republic",
      "KH": "Cambodia",
      "KI": "Kiribati",
      "KM": "Comoros",
      "CG": "Congo",
      "KN": "Saint Kitts And Nevis",
      "KW": "Kuwait",
      "KY": "Cayman Islands",
      "KZ": "Kazakhstan",
      "LA": "Laos",
      "LB": "Lebanon",
      "LC": "Saint Lucia",
      "LI": "Liechtenstein",
      "LK": "Sri Lanka",
      "LR": "Liberia",
      "LS": "Lesotho",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "LV": "Latvia",
      "LY": "Libya",
      "MA": "Morocco",
      "MC": "Monaco",
      "MD": "Moldova",
      "ME": "Montenegro",
      "MF": "St. Martin",
      "MG": "Madagascar",
      "MH": "Marshall Islands",
      "MK": "Macedonia",
      "ML": "Mali",
      "MM": "Myanmar",
      "MN": "Mongolia",
      "MO": "Macau",
      "MP": "Northern Mariana Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MS": "Montserrat",
      "MT": "Malta",
      "MU": "Mauritius",
      "MV": "Maldives",
      "MW": "Malawi",
      "MX": "Mexico",
      "MY": "Malaysia",
      "MZ": "Mozambique",
      "NA": "Namibia",
      "NC": "New Caledonia",
      "NE": "Niger",
      "NG": "Nigeria",
      "NI": "Nicaragua",
      "NL": "Netherlands",
      "NO": "Norway",
      "NP": "Nepal",
      "NR": "Nauru",
      "NU": "Niue",
      "NZ": "New Zealand",
      "OM": "Oman",
      "PA": "Panama",
      "PE": "Peru",
      "PF": "French Polynesia",
      "PG": "Papua New Guinea",
      "PH": "Philippines",
      "PK": "Pakistan",
      "PL": "Poland",
      "PR": "Puerto Rico",
      "PS": "Palestinian Authority",
      "PT": "Portugal",
      "PW": "Palau",
      "PY": "Paraguay",
      "QA": "Qatar",
      "KR": "Republic of Korea",
      "RE": "Reunion Island",
      "RO": "Romania",
      "S1": "St. Maarten",
      "RS": "Serbia",
      "RU": "Russia",
      "RW": "Rwanda",
      "SA": "Saudi Arabia",
      "SB": "Solomon Islands",
      "SC": "Seychelles",
      "SD": "Sudan",
      "SE": "Sweden",
      "SG": "Singapore",
      "SI": "Slovenia",
      "SK": "Slovakia",
      "SL": "Sierra Leone",
      "SN": "Senegal",
      "SO": "Somalia",
      "SR": "Suriname",
      "SS": "South Sudan",
      "SV": "El Salvador",
      "SY": "Syria",
      "SZ": "Swaziland",
      "TC": "Turks and Caicos Islands",
      "TD": "Chad",
      "TG": "Togo",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TK": "Tokelau",
      "TJ": "Tajikistan",
      "TM": "Turkmenistan",
      "TN": "Tunisia",
      "TO": "Tonga",
      "TR": "Turkey",
      "TT": "Trinidad and Tobago",
      "TV": "Tuvalu",
      "TW": "Taiwan",
      "TZ": "Tanzania",
      "UA": "Ukraine",
      "UG": "Uganda",
      "US": "United States",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VC": "Saint Vincent And The Grenadines",
      "VE": "Venezuela",
      "VG": "British Virgin Islands",
      "VI": "Virgin Islands (US)",
      "VN": "Vietnam",
      "VU": "Vanuatu",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Sao Tome and Principe",
      "XD": "St. Thomas",
      "XZ": "North Ireland",
      "YE": "Yemen",
      "YT": "Mayotte",
      "ZA": "South Africa",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    };
    if (/complete|interactive|loaded/.test(document.readyState)) {
        loadCarfDefaultForm();
    } else {
        window.addEventListener("load", loadCarfDefaultForm);
    }
}